import React from "react";

export default function ExchangeInformationTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: "교환요청",
      },
      {
        id: 2,
        title: (
          <span>
            교환거부
            <br />
            (구매확정)
          </span>
        ),
      },
      {
        id: 3,
        title: (
          <span>
            교환배송완료
            <br />
            (구매확정)
          </span>
        ),
      },
    ],
  };
  return (
    <>
      <div className="p-2 bg-primary-blue text-white font-bold">교환 정보</div>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.requests?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.refusal?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deliveryCompleted?.cases}건
              </td>
            </tr>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.requests?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.refusal?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deliveryCompleted?.amount}원
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
